import React from 'react'
import atoms from '../../atoms';
import constant from '../../../constants/constant';
import moment from 'moment';
import { findConstantLabel, priceTagFormatter } from '../../../constants/utils'
import BrandPlaceHolder from '../../../assets/Images/placeholderimg.png';
import { BarcodeDataProps } from './interface';

const { Image } = atoms
const Index = ({ barcodeData }: BarcodeDataProps) => {

    const style = {
        height: "100%",
        width: "100%",
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${barcodeData?.product?.images[0] || BrandPlaceHolder})`
    }

    const isContactLensProduct = barcodeData?.product?.is_contact_lens;

    return (
        <>
            <div className='row d-flex'>
                <div className='col-6'>
                    {/* <CarouselComp productDetails={barcodeData?.product} /> */}
                    <div
                        key="productImage"
                        style={style}
                        className='card img-fluid"'>
                    </div>

                    {/* </div> */}
                </div>
                <div className='col-6'>
                    <div className='d-flex align-items-center justify-content-start gap-2'>
                        <h2 className='mb-0 fs-16 fw-700' style={{ minWidth: "100px" }}>Product ID :</h2>
                        <div className='d-flex'>
                            <div className='id-input-design d-flex justify-content-between align-items-center gap-2'>
                                <h2 className='mb-0 fs-16 fw-400 dark-gray'>{barcodeData?.product?.product_id_display ? barcodeData?.product?.product_id_display : ""}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-start gap-2 mt-3'>
                        <h2 className='mb-0 fs-16 fw-700' style={{ minWidth: "100px" }}>Barcode :</h2>
                        <div className='d-flex'>
                            <div className='id-input-design d-flex justify-content-between align-items-center gap-2'>
                                <h2 className='mb-0 fs-16 fw-400 dark-gray'>{barcodeData?.bar_code ? barcodeData?.bar_code : ""}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-start gap-2 mt-3'>
                        <h2 className='mb-0 fs-16 fw-700' style={{ minWidth: "100px" }}>Store Name :</h2>
                        <h2 className='mb-0 fs-18 fw-400'>{barcodeData?.store?.store_name}</h2>
                    </div>
                    <div className="mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className='fs-20 fw-500'>{barcodeData?.product?.brand?.brand_name ? barcodeData?.product?.brand?.brand_name : ""}</span>
                        </div>
                    </div>
                    {barcodeData?.product?.description && <div className="mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-3 ">
                            <span className='fs-18 fw-700'>{barcodeData?.product?.description?.toUpperCase()}</span>
                        </div>
                    </div>}
                    <div className='row'>
                        <div className='col-6'>
                            <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Product SRP :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.product_srp ? priceTagFormatter(barcodeData?.product?.product_srp,barcodeData?.store?.region) : ""}</span>
                                </div>
                            </div>
                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-3 ">
                                    <h2 className='mb-0 fs-18 fw-600'>Brand Color Code :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.brand_color_code}</span>
                                </div>
                            </div>}
                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2 ">
                                    <h2 className='mb-0 fs-18 fw-600'>Lense Color :</h2>
                                    {barcodeData?.product?.lens_colors && barcodeData?.product?.lens_colors?.map((item: any, index: number) => {
                                        return (
                                            <span className='fs-18 fw-400'>{item?.color_name},</span>
                                        )
                                    })}
                                </div>
                            </div>}
                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Glass Size/Power :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.glass_size ? barcodeData?.product?.glass_size : ""}MM</span>
                                </div>
                            </div>}
                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Product With Case :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.product_with_case ? "Yes" : "No"}</span>
                                </div>
                            </div>}

                            {/* for contact lens product */}
                            {isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Lens Type :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.lens_type}</span>
                                </div>
                            </div>}
                            {isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Lens Name :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.lens_name || ''}</span>
                                </div>
                            </div>}
                            {/* end */}
                        </div>
                        <div className='col-6'>
                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2 ">
                                    <h2 className='mb-0 fs-18 fw-600'>Bridge Size :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.bridge_size ? barcodeData?.product?.bridge_size : ""}MM</span>
                                </div>
                            </div>}

                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Warrantee :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.warranty ? findConstantLabel(constant?.PRODUCT_WARRANTY, barcodeData?.product?.warranty) : "-"}</span>
                                </div>
                            </div>}

                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Product Color :</h2>
                                    {barcodeData?.product?.specx_colors && barcodeData?.product?.specx_colors?.map((item: any, index: number) => {
                                        return (
                                            <span className='fs-18 fw-400'>{item?.color_name},</span>
                                        )
                                    })}
                                </div>
                            </div>}

                            {!isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Temple Size :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.temple_size ? barcodeData?.product?.temple_size : ""}MM</span>
                                </div>
                            </div>}

                            {/* for contact lens product  */}
                            {isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Period Use :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.period_use && findConstantLabel(constant.PERIOD_USE, barcodeData?.product?.period_use)}</span>
                                </div>
                            </div>}
                            {isContactLensProduct && <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Pack of :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.product?.pack_of_quantity}</span>
                                </div>
                            </div>}
                            {/* end */}

                            <div className="mt-3">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <h2 className='mb-0 fs-18 fw-600'>Date of Last Audit :</h2>
                                    <span className='fs-18 fw-400'>{barcodeData?.audit_trails?.length > 0 ? moment(barcodeData?.audit_trails[0]?.createdAt)?.format("DD/MM/YYYY") : ""}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {barcodeData?.sku_number && <div className="mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <h2 className='mb-0 fs-18 fw-600'>SKU :</h2>
                            <span className='fs-18 fw-400'>{barcodeData?.sku_number?.sku_number ? barcodeData?.sku_number?.sku_number : ""}</span>
                        </div>
                    </div>}
                    {barcodeData?.item_condition && <div className="mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <h2 className='mb-0 fs-18 fw-600'>Condition of Items :</h2>
                            <span className='fs-18 fw-400'>{findConstantLabel(constant?.INVENTORY_ITEM_CONDITION, barcodeData?.item_condition)}</span>
                        </div>
                    </div>}
                    <div className="mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <h2 className='mb-0 fs-18 fw-600'>Product Condition Remark :</h2>
                            <span className='fs-18 fw-400'>{barcodeData?.condition_remark}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Index